import { render, staticRenderFns } from "./CouponSettingIframe.vue?vue&type=template&id=396db7f5&"
import script from "./CouponSettingIframe.vue?vue&type=script&lang=ts&"
export * from "./CouponSettingIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports